import PageForm from "../form";

const TermsAndConditions = ({ group }: { group: string }) => (
  <PageForm title="Terms and Conditions" Key={`${group}-terms-&-conditions`} />
);
export default TermsAndConditions;
